import { useState, useEffect } from "react";
import axiosInstance from "../../api/axiosInstance";

function TrustTeam() {
  const [members, setMembers] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [membersRes, settingsRes] = await Promise.all([
        axiosInstance.get("/api/team/trust"),
        axiosInstance.get("/api/settings"),
      ]);
      setMembers(membersRes.data);
      setSettings(settingsRes.data);
    } catch (err) {
      console.error("Failed to load trust team", err);
    } finally {
      setLoading(false);
    }
  };

  const primaryColor = settings?.theme_primary_color || "#0d6efd";

  return (
    <div>
      <section
        className="py-4 text-white"
        style={{ backgroundColor: primaryColor }}
      >
        <div className="container">
          <h1 className="fw-bold mb-0">Trust Team</h1>
          <p className="mb-0 opacity-75">{settings?.trust_name}</p>
        </div>
      </section>

      <div className="container py-5">
        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        ) : members.length === 0 ? (
          <p className="text-muted text-center py-5">
            Trust team details coming soon.
          </p>
        ) : (
          <div className="row g-4">
            {members.map((m) => (
              <div className="col-12 col-sm-6 col-lg-4" key={m.id}>
                <div className="card border-0 shadow-sm h-100 text-center">
                  <div className="card-body p-4">
                    <img
                      src={
                        m.photo_path
                          ? `${process.env.REACT_APP_API_URL}/${m.photo_path}`
                          : "https://via.placeholder.com/110?text=Photo"
                      }
                      alt={m.name}
                      className="rounded-circle mb-3"
                      style={{
                        width: "110px",
                        height: "110px",
                        objectFit: "cover",
                      }}
                    />
                    <h5 className="fw-bold mb-0">{m.name}</h5>
                    <p
                      style={{ color: primaryColor }}
                      className="small fw-medium mb-2"
                    >
                      {m.designation}
                    </p>
                    {m.bio && <p className="text-muted small mb-2">{m.bio}</p>}
                    <div className="d-flex justify-content-center gap-3 text-muted small">
                      {m.email && (
                        <a
                          href={`mailto:${m.email}`}
                          className="text-muted"
                          title={m.email}
                        >
                          <i className="bi bi-envelope"></i>
                        </a>
                      )}
                      {m.phone && (
                        <a
                          href={`tel:${m.phone}`}
                          className="text-muted"
                          title={m.phone}
                        >
                          <i className="bi bi-telephone"></i>
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default TrustTeam;
